var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectslogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "65.000000pt",
    height: "74.000000pt",
    viewBox: "0 0 65.000000 74.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,74.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 724 c0 -14 3 -14 15 -4 19 16 19 20 0 20 -8 0 -15 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 620 c-9 -15 -19 -19 -35 -15 -27 7 -52 -17 -43 -40 3 -10 -4 -26 -19 -41 -30 -30 -32 -50 -6 -64 13 -7 21 -23 23 -48 3 -35 5 -37 37 -38 24 -1 39 -8 49 -22 8 -12 22 -22 32 -22 10 0 24 10 32 22 10 14 25 21 49 22 32 1 34 3 37 38 2 25 10 41 23 48 25 14 24 42 -1 58 -12 7 -20 23 -20 41 0 34 -22 55 -49 46 -14 -4 -24 0 -33 14 -17 27 -59 27 -76 1z m58 -20 c11 -11 33 -20 49 -20 24 0 28 -3 24 -24 -3 -16 2 -31 17 -46 l22 -22 -22 -20 c-14 -13 -20 -29 -18 -46 3 -24 0 -27 -24 -24 -17 2 -34 -4 -49 -19 -21 -21 -23 -21 -35 -4 -7 9 -27 18 -45 20 -28 2 -32 6 -34 34 -2 18 -11 38 -20 45 -17 12 -17 14 4 35 15 15 21 31 18 47 -4 21 0 24 24 24 16 0 37 9 47 19 22 24 19 24 42 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 525 c-18 -19 -23 -31 -19 -48 15 -47 61 -61 95 -27 26 26 25 46 -5 75 -30 31 -40 31 -71 0z m61 -35 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 369 c-8 -14 -20 -20 -38 -18 -39 4 -52 -7 -52 -46 0 -24 -6 -38 -20 -45 -27 -14 -25 -34 5 -64 15 -15 22 -31 19 -41 -9 -23 16 -47 43 -40 16 4 28 -1 40 -15 22 -25 44 -25 66 0 12 14 24 19 40 15 27 -7 52 17 43 40 -3 10 4 26 19 41 31 31 31 41 1 69 -17 16 -23 30 -19 44 8 30 -11 48 -46 43 -22 -3 -32 1 -40 17 -15 27 -47 27 -61 0z m48 -25 c5 -9 24 -17 42 -19 29 -2 33 -6 35 -34 2 -18 11 -38 20 -45 17 -12 17 -14 -4 -35 -15 -15 -21 -31 -18 -47 4 -21 0 -24 -24 -24 -16 0 -38 -9 -49 -20 -20 -20 -20 -20 -40 0 -11 11 -33 20 -49 20 -24 0 -28 3 -24 24 3 16 -3 32 -18 47 -21 21 -21 23 -4 35 9 7 18 27 20 45 2 28 6 32 35 34 18 2 37 10 42 19 5 9 13 16 18 16 5 0 13 -7 18 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 278 c-30 -24 -31 -56 -4 -83 14 -14 30 -25 36 -25 6 0 22 11 36 25 18 19 23 31 19 48 -8 26 -32 47 -55 47 -9 0 -23 -6 -32 -12z m57 -48 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20 c0 -14 7 -20 22 -20 20 0 21 1 3 20 -10 11 -20 20 -22 20 -1 0 -3 -9 -3 -20z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectslogs);
export default __webpack_public_path__ + "static/media/projectslogs.1d6f4fbe7765a7213b02ac0596fb99d8.svg";
export { ForwardRef as ReactComponent };